import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
  transform(value: string | undefined): string {
    const html = marked.parse(value || '') as string;

    return html.replace(
      /<a /g,
      '<a target="_blank" rel="noopener noreferrer" '
    );
  }
}
